module.exports = __webpack_public_path__ + "images/emoji/smiley_cat.f847f4dd11ac3f4f4a9c.png";